export default __webpack_public_path__ + "static/media/fileAdd.dfbb1a9b.svg";